module.exports = __webpack_public_path__ + "img/120.179ff0cb.jpg";